module.exports = __webpack_public_path__ + "static/media/991773.785e8883.png";